// src/hooks/useOrientation.js

import { useState, useEffect } from 'react';

/**
 * useOrientation
 *
 * Returns 'landscape' or 'portrait' based on the window dimensions.
 * Landscape is where the width exceeds the height.
 *
 * Used by the member browse to switch between the landscape comparison
 * (three columns) and the portrait list (single column).
 */
export function useOrientation() {
  const getOrientation = () => {
    if (typeof window === 'undefined') return 'portrait';
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  };

  const [orientation, setOrientation] = useState(getOrientation);

  useEffect(() => {
    const handler = () => setOrientation(getOrientation());
    window.addEventListener('resize', handler);
    window.addEventListener('orientationchange', handler);
    return () => {
      window.removeEventListener('resize', handler);
      window.removeEventListener('orientationchange', handler);
    };
  }, []);

  return orientation;
}
